import { useNavigate } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { ADMIN_CLUSTERS } from "./adminNav";

// Department quick-action panels shown under the KPI grid.
const PANELS = [
  { cluster: "operations", blurb: "Live site telemetry, SRN case files and the board calendar.", actions: ["operations", "srn-ledger", "live-pulse", "board-motions"] },
  { cluster: "finance", blurb: "Core banking, wallets, settlements and commission flows.", actions: ["vcb", "payouts", "wallet", "settlement-desk"] },
  { cluster: "compliance", blurb: "KYC, agreements, signatory custody and the compliance log.", actions: ["verifications", "agreements", "signatory-vault", "compliance-log"] },
  { cluster: "users", blurb: "Approvals, onboarding and the empaneled partner registry.", actions: ["approvals", "onboarding-inbox", "users", "seller-ranking"] },
  { cluster: "catalog", blurb: "Master catalogue pricing and the daily rate flash.", actions: ["products", "rates"] },
  { cluster: "rfq", blurb: "Quote requests, broadcasts, price locks and order fulfilment.", actions: ["orders", "quote-requests", "rfq-broadcast", "price-lock"] },
  { cluster: "comms", blurb: "Notifications, outbound mail and brand collateral studios.", actions: ["notifications", "communications", "letterhead-studio", "brand-assets"] },
  { cluster: "settings", blurb: "Financial rules, fee schedules, governance and integrations.", actions: ["financial-rules", "fee-management", "data-governance", "zoho-books"] },
];

export function QuickActions({ onSelect, badges = {} }) {
  const nav = useNavigate();
  return (
    <section data-testid="quick-actions" className="mb-10">
      <div className="mb-6">
        <h2 className="text-base font-bold text-[#F5F5F5]">Department quick actions</h2>
        <p className="text-sm text-[#888888] mt-1">Jump straight into the desks that need attention.</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4 sm:gap-6">
        {PANELS.map((p, i) => {
          const cluster = ADMIN_CLUSTERS.find((c) => c.key === p.cluster); const Icon = cluster.icon;
          return (
            <div key={p.cluster} data-testid={`quick-panel-${p.cluster}`} className="admin-card admin-rise flex flex-col" style={{ animationDelay: `${i * 40}ms` }}>
              <div className="flex items-center gap-3">
                <span className="grid place-items-center w-10 h-10 rounded-lg bg-[#C9A84C]/10 border border-[#C9A84C]/30"><Icon size={18} className="text-[#C9A84C]" /></span>
                <h3 className="text-base font-bold text-[#F5F5F5]">{cluster.label}</h3>
              </div>
              <p className="text-sm text-[#888888] mt-4 leading-relaxed">{p.blurb}</p>
              <div className="mt-5 pt-5 border-t border-[#262626] space-y-1">
                {p.actions.map((k) => {
                  const item = cluster.items.find((x) => x.key === k); const ItemIcon = item.icon; const n = badges[item.badge];
                  return (
                    <button key={k} data-testid={`quick-action-${k}`} onClick={() => item.route ? nav(item.route) : onSelect(k)}
                      className="group w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm text-[#D4D4D4] hover:bg-[#242424] hover:text-[#F5F5F5] transition-colors duration-200">
                      <ItemIcon size={16} className="text-[#888888] group-hover:text-[#C9A84C] transition-colors" />
                      <span className="flex-1 text-left">{item.label}</span>
                      {n ? <span className="min-w-[22px] h-[22px] px-1.5 rounded-full bg-[#C9A84C] text-[#0D0D0D] text-sm font-bold grid place-items-center">{n}</span> : <ArrowUpRight size={16} className="text-[#333333] group-hover:text-[#C9A84C] transition-colors" />}
                    </button>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
